import { gql } from '@apollo/client';

export interface DspTaskTreeNode {
  taskId: number | null;
  taskName: string | null;
  unassignedParcelCount: number | null;
  assignedParcelCount: number | null;
  parcelNumberStart: number | null;
  parcelNumberEnd: number | null;
  dspName: string | null;
  driverId: number | null;
  driverName: string | null;
  status: number | null;
  subTaskList: DspTaskTreeNode[] | null;
}

export interface ListDspTasksByTaskDateResult {
  totalUnassignedParcels: number | null;
  totalAssignedParcels: number | null;
  taskList: DspTaskTreeNode[] | null;
}

export interface ListDspTasksByTaskDateResponse {
  listDspTasksByTaskDate: ListDspTasksByTaskDateResult;
}

export interface ListDspTasksByTaskDateVariables {
  request: {
    warehouseId: number;
    taskDate: string;
    dspId?: number | null;
  };
}

/** 仅两级：父任务 + subTaskList（第二级可为空），不再嵌套 subTaskList */
export const LIST_DSP_TASKS_BY_TASK_DATE = gql`
  query ListDspTasksByTaskDate($request: ListDspTasksByTaskDateRequestInput!) {
    listDspTasksByTaskDate(request: $request) {
      totalUnassignedParcels
      totalAssignedParcels
      taskList {
        taskId
        taskName
        unassignedParcelCount
        assignedParcelCount
        parcelNumberStart
        parcelNumberEnd
        dspName
        driverId
        driverName
        status
        subTaskList {
          taskId
          taskName
          unassignedParcelCount
          assignedParcelCount
          parcelNumberStart
          parcelNumberEnd
          dspName
          driverId
          driverName
          status
        }
      }
    }
  }
`;
